import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  downloadText: {
    id: 'views.CorporateGovernance.Document.downloadText',
    defaultMessage: 'POBIERZ PLIK PDF'
  },
  downloadAlternateText: {
    id: 'views.CorporateGovernance.Document.downloadAlternateText',
    defaultMessage: 'POBIERZ'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/Document/Document.intl.js